import { useTranslation } from 'react-i18next'
import { M_Fieldset } from 'src/M_Components'
import { ShipmentFormField } from './ShipmentFormField'

export const ShipmentPackages = ({ dataState, setDataState }) => {
    const { t } = useTranslation()

    return (
        <M_Fieldset
            labelInside
            label={
                <div style={{ display: 'flex', alignItems: 'center', gap: '8px', fontSize: '20px', marginLeft: '10px' }}>
                    <i className='pi pi-box' style={{ fontSize: '18px' }} />
                    {t('Packages')}
                </div>
            }
            elements={
                <div style={{ display: 'flex', flexDirection: 'column', padding: '10px' }}>
                    <div style={{ display: 'flex', alignItems: 'flex-end', flexWrap: 'wrap' }}>
                        <ShipmentFormField
                            fields={{ display: t('NrPacks'), code: 'NrPacks', type: 'number', size: '130px' }}
                            index={20}
                            data={dataState}
                            setData={setDataState}
                        />
                        <ShipmentFormField
                            fields={{
                                display: t('PackageCode'),
                                code: 'PackageCode',
                                type: 'foreignKey',
                                entity: 'package',
                                tableLabel: t('Package'),
                                filterField: 'Code',
                                labelFields: ['Code'],
                                fields: [
                                    { key: 'Code', value: 'PackageCode' },
                                    { key: 'Name', value: 'PackageName' },
                                    { key: 'Id', value: 'IdPackage' },
                                ],
                            }}
                            index={21}
                            data={dataState}
                            setData={setDataState}
                        />
                        <ShipmentFormField
                            fields={{ display: t('PackageName'), code: 'PackageName', type: 'disabled', grow: true }}
                            index={22}
                            data={dataState}
                            setData={setDataState}
                        />
                    </div>

                    <div style={{ display: 'flex', alignItems: 'flex-end', flexWrap: 'wrap' }}>
                        <ShipmentFormField
                            fields={{ display: t('NrInPacks'), code: 'NrInPacks', type: 'number', size: '130px' }}
                            index={23}
                            data={dataState}
                            setData={setDataState}
                        />
                        <ShipmentFormField
                            fields={{
                                display: t('InnerCode'),
                                code: 'InnerPackageCode',
                                type: 'foreignKey',
                                entity: 'package',
                                tableLabel: t('InnerPackage'),
                                filterField: 'Code',
                                labelFields: ['Code'],
                                fields: [
                                    { key: 'Code', value: 'InnerPackageCode' },
                                    { key: 'Name', value: 'InnerPackageName' },
                                    { key: 'Id', value: 'IdInnerPackage' },
                                ],
                            }}
                            index={24}
                            data={dataState}
                            setData={setDataState}
                        />
                        <ShipmentFormField
                            fields={{ display: t('InnerPacksName'), code: 'InnerPackageName', type: 'disabled', grow: true }}
                            index={25}
                            data={dataState}
                            setData={setDataState}
                        />
                    </div>
                </div>
            }
        />
    )
}
